import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { green } from "@mui/material/colors";
import { withRouter } from "react-router-dom";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminMarketingCampaignList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            {
              key: "campaignTypeId",
              name: "Campaign Category",
              type: "marketingCampaignCategory",
              filter: true,
            },
            { key: "name", name: "Name", type: "string" },
            {
              key: "isActive",
              name: "Active",
              type: "boolean",
              icon: "Check",
              color: green[500],
              width: "110",
            },
          ]}
          sort={[
            {
              key: "campaignTypeId",
              direction: "ascending",
              type: "marketingCampaignCategory",
            },
            {
              key: "name",
              direction: "ascending",
            },
          ]}
          rows={Object.values(this.context.marketingCampaignsIndexed)}
          onClick={(marketingCampaign) => {
            this.props.history.push({
              pathname: "/admin/marketingCampaign/" + marketingCampaign.id,
            });
          }}
        />
      );
    }
  },
);
